import React from 'react'

export default function About() {
    return (
            <div>
                <section id="about" className="colorlib-about" data-section="about">
                    <div className="colorlib-narrow-content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row row-bottom-padded-sm animate-box">
                                    <div className="col-md-12">
                                        <div className="about-desc">
                                            <span className="heading-meta">About Me</span>
                                            <h2 className="colorlib-heading">Who Am I?</h2>
                                            <p>Sr Technical Program Manager with 12+ years in project and program management, 6 of them in technical program management across fintech and supply chain finance. At KLYM, I scaled cross-functional teams across multiple squads, shipped 38+ platform releases, and drove a 42% infrastructure cost reduction through a C2C migration I scoped and delivered. Comfortable in both design reviews and OKR planning, I've been shaping how teams pair AI-assisted workflows with spec-driven development to allocate capacity and prioritize features effectively.</p>
                                            <p>Experienced across LATAM and North America, fluent in Spanish and English. With 2 years building ML models in Python, I bridge the gap between technical delivery and strategic business outcomes. Less process theater, more outcomes.</p>
                                            <p>In my personal space I love cycling 🚲, climbing 🐐 and traveling ✈️.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="colorlib-narrow-content">
                        <div className="row">
                            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box">
                                <span className="heading-meta">What I do?</span>
                                <h2 className="colorlib-heading">Here are some of my expertise</h2>
                            </div>
                        </div>
                        <div className="row row-pt-md">
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-1" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-trello" />
                                    </span>
                                    <div className="desc">
                                        <h3>Technical Program Management</h3>
                                        <p>6+ years leading cross-functional squads in fintech. Delivered 38+ platform releases at KLYM using Agile, OKRs, LEAN, and VSM.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-5" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-code-outline" />
                                    </span>
                                    <div className="desc">
                                        <h3>Programming</h3>
                                        <p>Primary stack in Python and SQL. Experience with Flask, DjangoREST, and CI/CD pipelines via GitLab and Azure DevOps.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-3" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-bar-graph" />
                                    </span>
                                    <div className="desc">
                                        <h3>AI / Data Science</h3>
                                        <p>Spec-driven development paired with AI-assisted workflows. Hands-on with TensorFlow, Keras, Scikit-learn, LangChain, and Pandas.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row row-pt-md">
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-2" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-lab2" />
                                    </span>
                                    <div className="desc">
                                        <h3>Agile Coaching</h3>
                                        <p>Certified Scrum Master and Product Owner. Upskilled 8 non-technical POs and contributed to OKR planning for 6 consecutive quarters.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-4" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-data" />
                                    </span>
                                    <div className="desc">
                                        <h3>DevOps &amp; Cloud</h3>
                                        <p>Architected a C2C migration saving $45K/month. Daily use of Docker, Kubernetes, AWS, Grafana, and GitLab for platform operations.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-center animate-box">
                                <div className="services color-6" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <span className="icon">
                                        <i className="icon-cog2" />
                                    </span>
                                    <div className="desc">
                                        <h3>Platform Delivery &amp; Fintech</h3>
                                        <p>Deep domain experience in supply chain finance (Confirming/Factoring). Achieved ISO 27001:2022 certification and increased NIM by 15% over 2 years.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*<div class="row">
                    <div class="col-md-12 animate-box">
                        <div class="hire">
                            <h2>I'm crazy to do things <br />Over 2.3k commits done, 291151+ lines of code and 28 repos </h2>
                            <a href="#" class="btn-hire">contact me</a>
                        </div>
                    </div>
        </div>*/}
                {/*<div id="colorlib-counter" class="colorlib-counters" style={{ backgroundImage: `url(images / cover_bg_1.jpg)` }} data-stellar-background-ratio="0.5">
                    <div class="overlay"></div>
                    <div class="colorlib-narrow-content">
                        <div class="row">
                        </div>
                        <div class="row">
                            <div class="col-md-3 text-center animate-box">
                                <span class="colorlib-counter js-counter" data-from="0" data-to="309" data-speed="5000" data-refresh-interval="50"></span>
                                <span class="colorlib-counter-label">Cups of coffee</span>
                            </div>
                            <div class="col-md-3 text-center animate-box">
                                <span class="colorlib-counter js-counter" data-from="0" data-to="356" data-speed="5000" data-refresh-interval="50"></span>
                                <span class="colorlib-counter-label">Projects</span>
                            </div>
                            <div class="col-md-3 text-center animate-box">
                                <span class="colorlib-counter js-counter" data-from="0" data-to="30" data-speed="5000" data-refresh-interval="50"></span>
                                <span class="colorlib-counter-label">Clients</span>
                            </div>
                            <div class="col-md-3 text-center animate-box">
                                <span class="colorlib-counter js-counter" data-from="0" data-to="10" data-speed="5000" data-refresh-interval="50"></span>
                                <span class="colorlib-counter-label">Partners</span>
                            </div>
                        </div>
                    </div>
        </div>*/}
            </div >

        );
}